/**
 * The container this viewer last had open, so a tenant page's nav and the flat paths
 * know where to go back to. A per-viewer convenience, nothing more: storage can be
 * missing, full or forbidden, and then the default container is where everything goes.
 */
const STORAGE_KEY = 'rypt.container';

export function readLastContainer(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function rememberContainer(containerId: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, containerId);
  } catch {
    // Remembering is a convenience; the default container is the answer without it.
  }
}
